import { render } from "./change-company.vue?vue&type=template&id=3ef19038&scoped=true&ts=true"
import script from "./change-company.vue?vue&type=script&lang=ts"
export * from "./change-company.vue?vue&type=script&lang=ts"

import "./change-company.vue?vue&type=style&index=0&id=3ef19038&scoped=true&lang=stylus"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef19038"]])

export default __exports__